// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iutd","colBig":"styles_colBig__1wBHQ","colSmall":"styles_colSmall__1eBOC"};